import { render, staticRenderFns } from "./ProfitLossDrillThrough.vue?vue&type=template&id=24e4f40a&scoped=true&"
import script from "./ProfitLossDrillThrough.vue?vue&type=script&lang=js&"
export * from "./ProfitLossDrillThrough.vue?vue&type=script&lang=js&"
import style0 from "./ProfitLossDrillThrough.vue?vue&type=style&index=0&id=24e4f40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4f40a",
  null
  
)

export default component.exports